<template>
    <div>
        <hts-modal
            :show="visible"
            :title="$t('labels.changePartner')"
            @close="close">
            <hts-form @submit="submit">
                <hts-form-select
                    v-if="!journey.separate"
                    v-model="partnerId"
                    v-model:text="partnerName"
                    class="w-full"
                    :items="allotmentOptions"
                    :filterable="true"
                    :label="$t('labels.fleetVehicle')"
                    key-id="_id"
                    required
                    key-label="name" />

                <hts-select-cooperator
                    v-if="journey.separate"
                    v-model="partnerId"
                    v-model:name="partnerName"
                    type-cooperator="PARTNER"
                    prop="vendor"
                    name-select="fleetVehicle"
                    size="small"
                    :creatable="true"
                    required
                    :label="$t('labels.fleetVehicle')"
                    :items="internalFleetVehicle"
                    @change="
                        () => {
                            contact = ''
                            contactName = ''
                        }
                    " />

                <hts-select-cooperator-contact
                    v-if="partnerId && partnerId !== 'internal' && journey.separate"
                    v-model="contact"
                    v-model:name="contactName"
                    :cooperator-id="partnerId"
                    :label="$t('labels.vendorPriceModule.contact')"
                    key-label="namePhone"
                    prop="contact"
                    size="small"
                    required
                    name-select="contact"
                    :creatable="true"
                    :param-prepare="partnerId" />

                <hts-form-radio
                    v-model="reason"
                    label="Lý do thay đổi đội xe"
                    :items="reasonOptions"
                    value-key="key"
                    label-key="label"
                    required />

                <hts-form-input
                    v-if="reason === 'other'"
                    v-model="reasonOrther"
                    required
                    label="Lý do khác" />

                <div class="flex mt-5 justify-end">
                    <hts-form-button
                        color="primary"
                        type="submit"
                        :loading="false"
                        :disabled="CDisabled"
                        @click="submit">
                        Xác nhận
                    </hts-form-button>

                    <hts-form-button
                        class="pl-2"
                        color="error"
                        @click="close">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import reasonOption from './reason'
import allotment from '~/composables/api-url/order/allotment'

const init = {
  id: '',
  order: '',
  type: '',
  idAllotmentOrder: '',
  partnerName: '',
  partnerId: '',
  separate: false
}

const emits = defineEmits(['refreshTables'])

const visible = ref(false as boolean)
const journey = ref({ ...init })
const dataOrder = ref<{ [key: string]: any }>({})

const partnerId = ref('')
const partnerName = ref('')
const contact = ref('')
const contactName = ref('')

const oldPartnerId = ref('')
const oldContact = ref('')

const { reason, reasonOrther, reasonOptions, CReasonLabel } = reasonOption()

const allotmentOptions = computed(() => {
  return dataOrder?.value?.allotment?.filter((item: any) => item.type !== 'other') || []
})

const open = async (id: string) => {
  await getJourney(id)
  visible.value = true
}

const getJourney = async (id: string) => {
  const api = $url.journey.get
  const data: any = await $api(api, { uriParams: { ID: id } })

  const resData: any = data.data.value

  if (resData?.success) {
    const temp = resData.data

    journey.value = temp
    if (temp.separate) {
      partnerId.value = temp.partnerId || 'internal'
      oldPartnerId.value = temp.partnerId || 'internal'
      partnerName.value = temp.partnerName
      contact.value = temp.partnerContact._id
      oldContact.value = temp.partnerContact._id
      contactName.value = temp.partnerContact.contactName
    } else {
      await getOrderData(temp.order?._id || temp.order)
      partnerId.value = temp.idAllotmentOrder
      partnerName.value = temp.partnerName
    }
  }
}

const getOrderData = async (id: string) => {
  const api = $url.order.order.detail
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value

  if (resData?.success) {
    dataOrder.value = resData.data
  }
}

const submit = $lodash.debounce(async () => {
  const api = $url.journey.distribution.changePartner

  const data: any = await $api(api, {
    uriParams: { ID: journey.value.id },
    body: {
      partnerId: partnerId.value || '',
      partnerName: partnerName.value || '',
      contact: contact.value || '',
      reasonChangePartner: reason.value,
      reasonChangePartnerLabel: CReasonLabel.value
    }
  })

  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.changeSuccess'))
    close()
  }
}, 300)

const CDisabled = computed(() => {
  if (!reason.value) {
    return true
  }
  if (reason.value === 'other' && !reasonOrther.value) {
    return true
  }
  if (!partnerId.value) {
    return true
  }
  if (partnerId.value && partnerId.value !== 'internal' && journey.value.separate && !contact.value) {
    return true
  }
  if (oldPartnerId.value === partnerId.value && oldContact.value === contact.value) {
    return true
  }
  if (oldPartnerId.value === partnerId.value) {
    return true
  }
  return false
})

const close = () => {
  ressetFields()
  visible.value = false
}

const ressetFields = () => {
  journey.value = { ...init }

  partnerId.value = ''
  partnerName.value = ''
  contact.value = ''
  contactName.value = ''

  reason.value = ''
  reasonOrther.value = ''
}

const internalFleetVehicle = [
  {
    _id: 'internal',
    name: $t('labels.internal')
  }
]

defineExpose({ open })
</script>
